import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "active-price" }
const _hoisted_2 = { class: "active-price-list" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_4 = { class: "flex justify-between sm:items-center mb-3" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "grid grid-rows-2 sm:flex items-center" }
const _hoisted_7 = {
  key: 0,
  class: "text-green text-sm sm:mr-4 order-2 sm:order-1"
}
const _hoisted_8 = {
  key: 1,
  class: "text-red text-sm sm:mr-4 order-2 sm:order-1"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "w-full flex" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/3 lg:w-1/5 md:w-1/4 mr-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle2" }, "Versi Revisi")
], -1)
const _hoisted_13 = { class: "w-2/3 lg:w-4/5 md:w-3/4" }
const _hoisted_14 = { class: "font-bold text-subtitle2" }
const _hoisted_15 = { class: "w-full flex" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/3 lg:w-1/5 md:w-1/4 mr-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle2" }, "Belaku Mulai")
], -1)
const _hoisted_17 = { class: "w-2/3 lg:w-4/5 md:w-3/4" }
const _hoisted_18 = { class: "font-bold text-subtitle2" }
const _hoisted_19 = { class: "w-full flex" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/3 lg:w-1/5 md:w-1/4 mr-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle2" }, "Perubahan")
], -1)
const _hoisted_21 = { class: "w-2/3 lg:w-4/5 md:w-3/4" }
const _hoisted_22 = { class: "font-bold text-subtitle2 text-primary" }
const _hoisted_23 = { class: "w-full flex" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/3 lg:w-1/5 md:w-1/4 mr-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle2" }, "Penumpang")
], -1)
const _hoisted_25 = { class: "w-2/3 lg:w-4/5 md:w-3/4" }
const _hoisted_26 = { class: "font-bold text-subtitle2 break-words" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActivePriceForm = _resolveComponent("ActivePriceForm")!
  const _component_HjpDataList = _resolveComponent("HjpDataList")!
  const _component_ListActions = _resolveComponent("ListActions")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_HjpCofirmModal = _resolveComponent("HjpCofirmModal")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_HjpDataList, {
        showHeader: _ctx.params.showHeader,
        endpoint: _ctx.params.endpoint,
        totalRow: _ctx.params.pageSize,
        fieldSearch: _ctx.params.fieldSearch,
        confirmDialogDelete: _ctx.params.confirmDialogDelete,
        searchValue: _ctx.params.searchValue
      }, {
        content: _withCtx(({ dataItems }) => [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataItems, (data) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "p-card p-component card-no-shadow py-5 px-6",
                key: data.Id
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h5", {
                    class: "font-bold cursor-pointer hover-primary break-words pr-4 sm:pr-0",
                    onClick: ($event: any) => (_ctx.redirectDetail(data.Id))
                  }, _toDisplayString(data.Name), 9, _hoisted_5),
                  _createElementVNode("div", _hoisted_6, [
                    (data.IsActive)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Aktif"))
                      : (_openBlock(), _createElementBlock("p", _hoisted_8, "Non Aktif")),
                    _createElementVNode("i", {
                      class: "pi pi-ellipsis-h text-right text-base cursor-pointer text-black order-1 sm:order-2",
                      onClick: ($event: any) => (_ctx.showDropDown($event, data))
                    }, null, 8, _hoisted_9)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("p", _hoisted_14, _toDisplayString(data.Version), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.moment(data.PeriodStart).locale('id').format('DD MMMM YYYY')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("p", _hoisted_22, _toDisplayString(data.LastActiveChanges), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("p", _hoisted_26, _toDisplayString(data.PassengerType), 1)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        form: _withCtx(() => [
          _createVNode(_component_ActivePriceForm)
        ]),
        _: 1
      }, 8, ["showHeader", "endpoint", "totalRow", "fieldSearch", "confirmDialogDelete", "searchValue"])
    ]),
    _createVNode(_component_OverlayPanel, { ref: "op" }, {
      default: _withCtx(() => [
        _createVNode(_component_ListActions, {
          edit: true,
          del: true,
          editTitle: "Edit Harga",
          delTitle: "Hapus harga",
          onDel: _ctx.onDelete,
          onEdit: _ctx.onEdit
        }, null, 8, ["onDel", "onEdit"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_HjpCofirmModal, {
      show: _ctx.attrModalConfirmation.show,
      imgContent: _ctx.attrModalConfirmation.imgContent,
      title: _ctx.attrModalConfirmation.title,
      subTitle: _ctx.attrModalConfirmation.subTitle,
      btnSubmitTitle: _ctx.attrModalConfirmation.btnSubmitTitle,
      onHideDialog: _ctx.hideDialogConfirmation,
      onOnSubmit: _ctx.onSubmitConfirmation
    }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle", "onHideDialog", "onOnSubmit"])
  ]))
}